<template>
  <div class="side-container">
    <div class="side-toggle">
      <el-switch v-model="activeSwitch"></el-switch>
    </div>
    <div v-if="featuresSelected.length > 0">
      <div class="side-title">
        {{ $t('settings.integration.side-bar.features.title') }}
      </div>
      <div
        class="side-item"
        v-for="feature in featuresSelected"
        :key="feature.type"
      >
        <font-awesome-icon :icon="['fas', 'check']" color="#8CB369" />
        <span>{{ feature.name }}</span>
      </div>
    </div>
    <div v-if="links.length > 0">
      <div class="side-title">
        {{ $t('settings.integration.side-bar.links.title') }}
      </div>

      <div class="side-item" v-for="link in links" :key="link.name">
        <a :href="link.href" target="_blank">{{ link.name }}</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'integration-settings-drawer-side',
  components: {},
  props: {
    active: {
      type: Boolean,
      default: false,
    },
    types: {
      type: Array,
      required: true,
    },
    links: {
      type: Array,
      required: true,
    },
  },
  created() {},
  computed: {
    featuresSelected() {
      return this.features.filter(({ type }) => {
        return this.types.includes(type);
      });
    },
    activeSwitch: {
      get() {
        return this.active;
      },
      set(value) {
        this.$emit('switched', value);
      },
    },
  },
  data() {
    return {
      features: [
        {
          name: this.$t('settings.integration.side-bar.features.app'),
          type: 'APP',
        },
        {
          name: this.$t('settings.integration.side-bar.features.automation'),
          type: 'AUTOMATION',
        },
        {
          name: this.$t('settings.integration.side-bar.features.import'),
          type: 'IMPORT',
        },
        {
          name: this.$t('settings.integration.side-bar.features.preferences'),
          type: 'PREFERENCES',
        },
      ],
    };
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.side-container {
  width: max-content;
}
.side-title {
  font-size: 16px;
  font-weight: bold;
  padding: 8px 0;
}

.side-toggle {
  display: flex;
  justify-content: center;
  margin-bottom: 2rem;
}

.side-item {
  font-size: 12px;
  font-weight: normal;
  padding: 4px 0;
  span {
    margin-left: 10px;
  }
}
</style>